<template>
    <div class="box">
        <div class="d-gray p-a">
            <span>Decyzje kwalifikacyjne dostawcy</span>
        </div>
        <div class="box-divider m-a-0"/>
        <table class="table" v-if="!isLoading && qualifications.length > 0">
            <thead class="primary-color">
                <tr>
                    <th>Rok</th>
                    <th>Kwartał</th>
                    <th>Decyzja</th>
                    <th>Komentarze</th>
                    <th>Data utworzenia</th>
                    <th>Utworzył</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="q in qualifications" :key="q._id">
                    <td>{{ q.year }}</td>
                    <td>Q{{ q.quarter }}</td>
                    <td>
                        <span class="label" :class="q.qualified ? 'success' : 'danger'">
                            {{ q.qualified ? 'Zakwalifikowany' : 'Niezakwalifikowany' }}
                        </span>
                    </td>
                    <td>
                        <span v-if="q.comments" class="text-muted">{{ q.comments }}</span>
                        <span v-else class="text-muted">—</span>
                    </td>
                    <td>{{ formatDate(q.createdAt) }}</td>
                    <td>{{ SystemUsersManager.getName(q.createdBy) }}</td>
                </tr>
            </tbody>
        </table>

        <div class="row">
            <div class="col-sm-12 text-right text-center-xs">
                <paginate
                    v-model="page"
                    :page-count="pages"
                    :click-handler="changePage"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination pagination-sm m-r'"/>
            </div>
        </div>

        <div v-if="!isLoading && qualifications.length === 0" class="text-center text-muted p-4">
            Brak decyzji kwalifikacyjnych
        </div>
        <Spinner v-if="isLoading"/>
    </div>
</template>
<script>
import Api from '../../Api.js';
import Spinner from '../Spinner.vue';
import SystemUsersManager from '../../SystemUsersManager.js';
import moment from 'moment';

export default {
    name: 'CustomerSupplierQualifications',

    props: {
        customer: Object
    },

    components: {
        Spinner
    },

    data: function () {
        return {
            isLoading: false,
            qualifications: [],
            page: 1,
            limit: 20,
            pages: 1,
            SystemUsersManager: SystemUsersManager
        };
    },

    created: function () {
        this.loadData();
    },

    methods: {
        /**
         * Pobiera decyzje kwalifikacyjne dla bieżącego klienta (dostawcy).
         */
        async loadData() {
            this.isLoading = true;
            try {
                await SystemUsersManager.ensureLoaded();
                const { items, total } = await Api.iso.suppliers.qualifications.get({
                    supplierId: this.customer._id,
                    page: this.page,
                    limit: this.limit
                });
                this.qualifications = items;
                this.pages = Math.ceil(total / this.limit);
            } catch (error) {
                this.$h.commonApiError(error);
            }
            this.isLoading = false;
        },

        changePage() {
            this.loadData();
        },

        formatDate(date) {
            if (!date) return '—';
            return moment(date).format('YYYY-MM-DD HH:mm');
        }
    }
};
</script>
